module.exports = __webpack_public_path__ + "static/headshot-1c-square-f28beb9e8cde4fbf454cdf1ab2dc4efb.png";